// extracted by mini-css-extract-plugin
module.exports = {"error":"ReviewForm_error__-ZDxP","reviewRating":"ReviewForm_reviewRating__28kBp","reviewContent":"ReviewForm_reviewContent__3LqSK"};